export const formatTimestamp = (timestamp: number | string, locale: string, isFullYearFormat = false): string => {
    let date = new Date(timestamp);
    if (typeof timestamp === 'number') {
        date = new Date(timestamp * 1000);
    }
    if (locale === 'de-AT') {
        const options: Intl.DateTimeFormatOptions = {
            day: '2-digit',
            month: '2-digit',
            year: isFullYearFormat ? 'numeric' : '2-digit',
            timeZone: 'UTC'
        };
        return date.toLocaleDateString(locale, options);
    }

    // English has some special rules
    const options: Intl.DateTimeFormatOptions = {
        year: 'numeric',
        month: 'long',
        day: 'numeric',
        timeZone: 'UTC'
    };
    const dateTimeFormat = new Intl.DateTimeFormat('en-US', options);
    const parts = dateTimeFormat.formatToParts(date);
    let formattedDate = '';
    for (const part of parts) {
        switch (part.type) {
            case 'day':
                formattedDate += `${part.value}, `;
                break;
            case 'month':
                formattedDate = part.value.length <= 4
                    ? part.value + ' ' + formattedDate
                    : part.value.slice(0, 3) + '. ' + formattedDate;
                break;
            case 'year':
                formattedDate += part.value;
                break;
            default:
                break;
        }
    }

    return formattedDate;
};
